export const generatePages = (activePage, totalPages) => {
    const MAX_VISIBLE = 5;
    const ELLIPSIS = '...';
    const showEllipsis = (total) => total > MAX_VISIBLE + 2;
    const showEllipsisAtTheBeggining = (active) => active < MAX_VISIBLE;
    const showEllipsisAtTheEnd = (active, total) => active > total + 1 - MAX_VISIBLE;
    const showEllipsisAtBothEnds = (active, total) => active >= MAX_VISIBLE && active <= total + 1 - MAX_VISIBLE;
    const pages = [];
    pages.push(1);
    if (showEllipsis(totalPages)) {
        if (showEllipsisAtTheBeggining(activePage)) {
            for (let i = 2; i <= MAX_VISIBLE; i += 1) {
                pages.push(i);
            }
            pages.push(ELLIPSIS);
            pages.push(totalPages);
        }
        if (showEllipsisAtTheEnd(activePage, totalPages)) {
            pages.push(ELLIPSIS);
            for (let i = totalPages + 1 - MAX_VISIBLE; i <= totalPages; i += 1) {
                pages.push(i);
            }
        }
        if (showEllipsisAtBothEnds(activePage, totalPages)) {
            pages.push(ELLIPSIS, activePage - 1, activePage, activePage + 1, ELLIPSIS);
            pages.push(totalPages);
        }
    }
    else {
        for (let i = 2; i <= totalPages; i += 1) {
            pages.push(i);
        }
    }
    return pages;
};
//# sourceMappingURL=page-generator-service.js.map